import React from 'react';
import { Route } from 'react-router-dom';
import virtualCard from './virtualCard';

export default <Route path="/homepage/carteirinha" component={virtualCard} />;
